<template>
    <q-field :error="hasError"
             :error-label="errorLabel | capitalize"
             :label="label | capitalize"
             :helper="helper"
             :label-width="12"
             ref="QField">
        <template slot="label">
            <slot class="font-input-display" name="label" v-if="$slots.label">{{ label | capitalize }}:</slot>
        </template>
        <slot></slot>
    </q-field>
</template>

<script>
    import {QField} from 'quasar-framework'

    export default {
        name: 'VField',

        props: {
            label: String,
            helper: String,
            errorLabel: String,
            hasError: Boolean
        },

        components: {
            QField
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VField.vue